module.exports = __webpack_public_path__ + "img/back02.07d0453a.png";